import { render, staticRenderFns } from "./MarketplaceProduct.vue?vue&type=template&id=a6fe9c46&scoped=true&"
import script from "./MarketplaceProduct.vue?vue&type=script&lang=js&"
export * from "./MarketplaceProduct.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceProduct.vue?vue&type=style&index=0&id=a6fe9c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fe9c46",
  null
  
)

export default component.exports